import React, {useEffect, useState} from 'react';
import Grid from "@mui/material/Grid2";
import {connect} from "react-redux";
import Loader from "./layout/loading/loader";
import ButtonCreate from "./layout/ButtonCreate";
import Constants from "../../utils/constants";
import {Engineering} from "@mui/icons-material";
import PageTitle from "./layout/PageTitle";
import {prestationsActions} from "../../modules/prestations/prestations.actions.js";
import PrestationsTable from "./prestations/PrestationsTable.js";
import Button from "@mui/material/Button";
import {WaterIcon} from "../../utils/ui/Icons/WaterIcon.js";
import {WorkIcon} from "../../utils/ui/Icons/WorkIcon.js";
import TypologiesLavageTable from "./prestations/TypologiesLavageTable.js";
import {Stack} from "@mui/material";


const getCategory = () => {
    const storedMode = window.localStorage.getItem("prestations_category_view");
    return storedMode || Constants.PRESTATION_CATEGORY_PRESTATIONS;
};

function PrestationsPage({dispatch, ...props}) {
    const [category, setCategory] = useState(getCategory())

    useEffect(() => {
        if (!props.prestations && !props.loading && !props.error) {
            dispatch(prestationsActions.fetchPrestations())
        }
    }, [dispatch, props.prestations]);

    useEffect(() => {
        if (!props.typologiesLavage && !props.loading && !props.error) {
            dispatch(prestationsActions.fetchTypologies())
        }
    }, [dispatch, props.typologiesLavage]);

    const handleModeChange = (value) => {
        window.localStorage.setItem("prestations_category_view", value);
        setCategory(value)
    }

    const getRoute = () => {
        return category === Constants.PRESTATION_CATEGORY_PRESTATIONS ? Constants.APP_ROUTE_ADMIN_PRESTATIONS_NEW : Constants.APP_ROUTE_ADMIN_TYPOLOGIES_NEW
    }

    const getRouteLibelle = () => {
        return category === Constants.PRESTATION_CATEGORY_PRESTATIONS ? "Ajouter une prestation" : "Ajouter une typologie";
    }

    const handleDelete = (p) => {
        dispatch(prestationsActions.deletePrestation(p.id));
    }

    const handleDeleteTypologie = (t) => {
        dispatch(prestationsActions.deleteTypologie(t.id));
    }

    return (
        <>
	        <Stack direction="row" justifyContent={"space-between"} spacing={2}>
		        <PageTitle title={"Gestion des prestations"} icon={<Engineering/>}/>
		        <ButtonCreate route={getRoute()} label={getRouteLibelle()}/>
	        </Stack>


            <Grid container justifyContent={"center"} spacing={2} className={"mb-2"}>
                <Grid item>
                    <Button
                        variant={getCategory() === Constants.PRESTATION_CATEGORY_PRESTATIONS ? "contained" : "outlined"}
                        color="primary"
                        startIcon={<WorkIcon/>}
                        onClick={() => handleModeChange(Constants.PRESTATION_CATEGORY_PRESTATIONS)}
                    >
                        PRESTATIONS
                    </Button>
                </Grid>
                <Grid item>
                    <Button
                        variant={getCategory() === Constants.PRESTATION_CATEGORY_TYPOLOGIELAVAGE ? "contained" : "outlined"}
                        color="primary"
                        startIcon={<WaterIcon/>}
                        onClick={() => handleModeChange(Constants.PRESTATION_CATEGORY_TYPOLOGIELAVAGE)}
                    >
                        TYPOLOGIE LAVAGE
                    </Button>
                </Grid>
            </Grid>

            {props.loading &&
                <Loader/>
            }
            {!props.loading && category === Constants.PRESTATION_CATEGORY_PRESTATIONS &&
                <PrestationsTable prestations={props.prestations} onDelete={handleDelete}/>
            }
            {!props.loading && category === Constants.PRESTATION_CATEGORY_TYPOLOGIELAVAGE &&
                <TypologiesLavageTable typologies={props.typologiesLavage} onDelete={handleDeleteTypologie}/>
            }
        </>
    )
}

const mapStateToProps = function (state) {
    return {
        prestations: state.prestations.prestations,
        typologiesLavage: state.prestations.typologiesLavage,
        loading: state.prestations.loading,
        error: state.prestations.error
    }
}

export default connect(mapStateToProps)(PrestationsPage);
